<div class="FixedGraphContainer">
  <svg xmlns="http://www.w3.org/2000/svg" width="220px" height="150px" viewBox="0 0 220 150px">
    <g class="circleGraph">
      <defs>
        <linearGradient id="linearOne" x1="20" y1="120" x2="30.4" y2="80" gradientUnits="userSpaceOnUse">
          <stop offset="0.2" class="red"/>
          <stop  offset="0.8" class="orange"/>
        </linearGradient>
        <linearGradient id="linearTwo" x1="30.4" y1="80" x2="60" y2="50.4" gradientUnits="userSpaceOnUse">
          <stop offset="0.2" class="orange"/>
          <stop  offset="0.8" class="yellow"/>
        </linearGradient>
        <linearGradient id="linearTree" x1="60" y1="50.4" x2="100" y2="40" gradientUnits="userSpaceOnUse">
          <stop offset="0.2" class="yellow"/>
          <stop  offset="0.8" class="green"/>
        </linearGradient>
        <linearGradient id="linearFour" x1="100" y1="40" x2="140" y2="50.4" gradientUnits="userSpaceOnUse">
          <stop offset="0.2" class="green"/>
          <stop  offset="0.8" class="yellow"/>
        </linearGradient>
        <linearGradient id="linearFive" x1="140" y1="50.4" x2="169.6" y2="80" gradientUnits="userSpaceOnUse">
          <stop offset="0.2" class="yellow"/>
          <stop  offset="0.8" class="orange"/>
        </linearGradient>
        <linearGradient id="linearSix"  x1="140" y1="50.4" x2="180" y2="120" gradientUnits="userSpaceOnUse">
          <stop offset="0.2" class="red"/>
          <stop  offset="0.8" class="orange"/>
        </linearGradient>

      </defs>
      <path #speedmeter stroke="blue" fill="white" d="M180,120  A80,80 0 0,0 20,120 "/>
      <path class="circle-gradient six" d="M180,120 A80,80 0 0,0 169.6,80"/>
      <path class="circle-gradient five" d="M169.6,80 A80,80 0 0,0 140,50.4"/>
      <path class="circle-gradient four" d="M140,50.4 A80,80 0 0,0 100,40"/>
      <path class="circle-gradient tree" d="M100,40 A80,80 0 0,0 60,50.4"/>
      <path class="circle-gradient two" d="M60,50.4 A80,80 0 0,0 30.4,80"/>
      <path class="circle-gradient one" d="M30.4,80 A80,80 0 0,0 20,120"/>

      @for (value of ranges; track value; let i = $index) {
        <g>
          <text class="label"
            [attr.x]="labelPosition(value, speedmeter, 'x', true, i)"
            [attr.y]="labelPosition(value, speedmeter, 'y', true, i)"
            [attr.transform]="'rotate('+labelRotation(i)+')'">
            {{value}}%
          </text>
          <line class="line"
            [attr.x1]="labelPosition(value, speedmeter, 'x') - 10"
            [attr.x2]="labelPosition(value, speedmeter, 'x')"
            [attr.y1]="labelPosition(value, speedmeter, 'y')"
            [attr.y2]="labelPosition(value, speedmeter, 'y')"
            [attr.transform]="'rotate('+lineRotation(i)+')'"/>
        </g>
      }
      <circle r="12" cy="0" cx="0" id="dot" #dot
        [ngClass]="getCircleClass()"
        class="needle"
        [attr.transform]="calculatePositionDot(speedmeter)"
        />
      <text class="value" x="100" y="108" [ngClass]="getValueClass()">
        @if (type == 'number') {
          <tspan>{{value | number:'1.0-2'}}</tspan>
        }
        @if (type == 'minutes') {
          <tspan>{{_gS.getTime(value)}}</tspan>
        }
      </text>
      <text class="description" x="100" y="122">{{getLabel()}}</text>
      <text class="total" x="100" y="135">
        @if (type == 'number') {
          <tspan>{{total | number:'1.0-2'}}</tspan>
        }
        @if (type == 'minutes') {
          <tspan>{{_gS.getTime(total)}}</tspan>
        }
      </text>
    </g>
  </svg>
</div>
